<ng-container *ngIf="showUserInfo">
  <div class="d-flex flex-row-reverse justify-content-end justify-content-md-start">
    <div id="userprofile">
      <p-menu #menu [model]="menuItems" [popup]="true"></p-menu>
      <button #menuBtn type="button" class="btn btn-link" (click)="menu.toggle($event)" aria-haspopup="true" aria-label="View application menu"><i aria-hidden="true" class="fas fa-user fa-inverse bg-danger rounded-circle p-2 mx-2 align-middle"></i></button>
      <button role="link" class="btn btn-link" (click)="openHelpLink()"><i aria-hidden="true" class="fas fa-question-circle bg-primary rounded-circle align-middle" style="color: #FFFFFF;font-size: 17px;"></i> Help</button>
    </div>
    <div class="text-right">
      <span class="text-white">{{userDisplayName}}</span><br />
      <button type="button" class="btn btn-link" (click)="logout()">Log out</button>
    </div>
  </div>
</ng-container>
